import {config, http} from './__http';

export default {

    // NOTIFICATION
    getCurrentBanner(banner, params) {
        http.get(config.baseUrl()+'/banner/current?locationType='+params).then(response => {
            banner(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    createBanner(banner, params) {
        http.post(config.baseUrl()+'/banner', params).then(response => {
            banner(response.data);
        }).catch(e => {
            banner(e.response);
        });
    },
    getBranchOptions(branches, params) {
        http.get(config.baseUrl()+'/branch').then(response => {
            branches(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    getBanners(banners, params) {
        http.get(config.baseUrl()+'/banner', params).then(response => {
            banners(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    getBanner(banner, id) {
        http.get(config.baseUrl()+'/banner/'+id).then(response => {
            banner(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    updateBanner(banner, params) {
        http.put(config.baseUrl()+'/banner/'+params.Id, params).then(response => {
            banner(response.data)
        }).catch(e => {
            banner(e.response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/Banner.js